












































































































































































































import Component from "vue-class-component";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { DetailIncomingItem } from "@/store/statistics/types";
import { Getter } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { ScrollButton } from "wings-ui-components";
import DetailIncomingFilter from "@/components/Statistics/DetailIncomingFilter.vue";
import { Prop } from "vue-property-decorator";
import {MsgTransports} from "@/store/types";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: { DetailIncomingFilter, ScrollButton },
  filters: { dateFilter },
  methods: {colorClassByStatus}
})
export default class DetailIncoming extends BaseItemsPage<DetailIncomingItem> {
  @Prop() transport!: MsgTransports;
  @Getter("statisticDetailIncoming") responseItems!: DetailIncomingItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter = true;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "service_provider",
      "partner",
      "message",
      "status",
      "error_code",
      "detail",
    ];
  }

  getData() {
    return this.responseItems;
  }
}
